import { connect } from 'react-redux'
import InternalReportsPage from '../components/pages/InternalReportsPage'
import { getAccountProfile } from '../reducers/accountReducer'

const mapStateToProps = ({ account }) => ({
  accountProfile: getAccountProfile(account),
})

export default connect(mapStateToProps)(InternalReportsPage)
